module.exports = __webpack_public_path__ + "img/kjsy_gallery8.b95c96b6.jpg";